import { React, useRef } from "react";
import { TileLayer, Marker, Popup, MapContainer } from 'react-leaflet';
import Leaflet from "leaflet";
import { FiEdit3 } from 'react-icons/fi';
import mapPinBlack from '../../assets/pins/markerDefault.png';
import mapPinResolvido from '../../assets/pins/markerResolvido.png';
import mapPinNovo from '../../assets/pins/markerNovo.png';
import mapPinEmAnalise from '../../assets/pins/markerEmAnalise.png';
import mapPinExecucao from '../../assets/pins/markerExecucao.png';
import InfoComplaint from './infoComplaint';
import MenuIcon from '@mui/icons-material/Menu';
import './styles.css';
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useMapFilter } from "../../hooks/map/useMapFilter";

const COLORS = {
  'Novo': { color: '#db5050' },
  'Em análise': { color: '#2c5fb8' },
  'Resolvido': { color: '#3bb410' },
  'Indeferido': { color: '#57576d' },
}

const mapIconBlack = Leaflet.icon({
  iconUrl: mapPinBlack,
  iconSize: [20, 32]
});

const mapIconResolvido = Leaflet.icon({
  iconUrl: mapPinResolvido,
  iconSize: [20, 32]
});

const mapIconNovo = Leaflet.icon({
  iconUrl: mapPinNovo,
  iconSize: [20, 32]
});

const mapIconEmAnalise = Leaflet.icon({
  iconUrl: mapPinEmAnalise,
  iconSize: [20, 32]
});

const mapIconExecucao = Leaflet.icon({
  iconUrl: mapPinExecucao,
  iconSize: [20, 32]
});

// Mapeamento de status para etapa (mesmo usado no filtro)
const STATUS_TO_STEP = {
  'Novo': 'Abertura',
  'Em análise': 'Homologação',
  'Aguardando Informação': 'Homologação',
  'Autorizado/Aprovado': 'Homologação',
  'Solução de longo prazo / Sugestão de projeto': 'Homologação',
  'Em execução': 'Execução',
  'Encaminhado para o executor': 'Execução',
  'Notificado para providências': 'Execução',
  'Resolvido': 'Conclusão',
  'Indeferido': 'Conclusão',
  'Respondido': 'Conclusão',
  'Detecção incorreta': 'Conclusão',
};

const getIcon = (data) => {
  // Calcular a etapa baseado no status real
  const step = STATUS_TO_STEP[data.status] || data.statusStep;

  const map = {
    'Abertura': mapIconNovo,        // Vermelho
    'Homologação': mapIconEmAnalise, // Azul
    'Execução': mapIconExecucao,     // Amarelo
    'Conclusão': mapIconResolvido,   // Verde
  }

  return map[step] || mapIconBlack;
}


export default function SideBarMap() {

  const navigate = useNavigate();

  const mapRef = useRef(null);

  const {
    mapPosition, setMapPosition,
    mapZoom, setZoom,
    selectedItem, setSelectedItem,
    complaints
  } = useMapFilter();

  function formatDate(date) {
    date = new Date(date);

    return (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
      (date.getMonth() + 1 > 9 ? (date.getMonth() + 1) : "0" + (date.getMonth() + 1)) + "/" +
      date.getFullYear();
  }

  // logo após o GET
  console.log('complaints length:', complaints.length);
  console.log('statusSteps distintos:', [...new Set(complaints.map(c => c.statusStep))]);

  return (
    <Grid id={'map-side'} container style={{ width: "100%", height: "100%" }} justifyContent='center'>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <div ref={mapRef} className='map' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <MapContainer
            center={mapPosition}
            zoom={mapZoom}
            scrollWheelZoom={false}
            style={{ width: "100%", height: "100%" }}
          >

            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {complaints.map(response => (
              <Marker position={[response.latitude, response.longitute]} key={response.id}
                icon={getIcon(response)}>

                <Popup
                  closeButton={false}
                  minWidth={240}
                  maxWidth={240}
                  className="map-popup">
                  <div>
                    <h6>{response.area}</h6>
                    <p> <strong>Descrição:</strong> {response.description} </p>
                    <p> <strong>Data de Criação:</strong> {formatDate(response.createdAt)} </p>
                    <p >
                      <strong>Status:
                        <span style={COLORS[response.status]}>
                          {" " + response.status}
                        </span>
                      </strong>
                    </p>
                    <p> <strong>Executor:</strong>
                      {response.executorName || " Sem executor"}
                    </p>
                    <a href={`/details/${response.id}`} onClick={(e) => {
                      e.preventDefault();
                      navigate(`/details/${response.id}`, { state: { from: [{ name: 'Mapa', href: '/map' }] } });
                    }}  > <FiEdit3 size={20} color='#794f35' /> </a>
                  </div>
                </Popup>
              </Marker>
            ))}

            <div className="side">
              <div className="side-info">
                <MenuIcon fontSize="small" className="icon" style={{ 'color': '#41414d' }} />
                <div className="denuncias-container">
                  <InfoComplaint complaints={complaints} itemCliked={selectedItem} setItemCliked={setSelectedItem} />
                </div>
              </div>
            </div>

          </MapContainer>
        </div >
      </Grid>
    </Grid>
  );
}
